export class SubContractorListSearch {
  subcontractorid: number;
  listType: number;
  pageSize: number;
  page: number;
}
